// docs: https://github.com/altostra/type-validations#readme
import { objectOf /*, maybe */ } from "@altostra/type-validations";
// import { boolean, number } from "@altostra/type-validations/lib/primitives";

export const isPostMessageResult = objectOf({});
